<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M15.25 10.5493V15.25C15.25 16.0784 14.5784 16.75 13.75 16.75H6.25C5.42157 16.75 4.75 16.0784 4.75 15.25V10.5493M15.25 10.5493V10.375M15.25 10.5493C15.6984 10.2899 16 9.80522 16 9.25C16 8.42157 15.3284 7.75 14.5 7.75H5.5C4.67157 7.75 4 8.42157 4 9.25C4 9.80522 4.30165 10.2899 4.75 10.5493M15.25 10.5493C15.0293 10.6769 14.7732 10.75 14.5 10.75H5.5C5.22678 10.75 4.97063 10.6769 4.75 10.5493M4.75 10.5493V10.375M10 7.75V6.5M10 7.75H8.74997C7.36928 7.75 6.25 6.63071 6.25 5.25C6.25 4.55964 6.80964 4 7.5 4C8.8807 4 10 5.11929 10 6.5M10 7.75H11.25C12.6307 7.75 13.75 6.63071 13.75 5.25C13.75 4.55964 13.1903 4 12.5 4C11.1193 4 10 5.11929 10 6.5M10 7.75V16.75" 
    stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'GiftBoxIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>